module.exports = __webpack_public_path__ + "static/media/expertise-first-image.ae9882a5.png";